<aside class="sidebar-left-wrapper">
  <div class="sidebar-left__logo-wrapper">
    <app-logo></app-logo>
    <app-logo-slogan></app-logo-slogan>
    <app-version></app-version>
  </div>

  <nav class="sidebar-left__nav-wrapper">
    <ng-scrollbar autoHeightDisabled="false">
      <app-menu-vertical></app-menu-vertical>
    </ng-scrollbar>
  </nav>
</aside>
